
import { useRef, useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';

import { authCheck, fetchPatientDocument, savePatientDocument } from '../../actions/formAction';
import Translate from "../Translate";

const FormPage = props => {
     
    const formioRef = useRef();
    const [ loadingStatus, setLoadingState ] = useState(true);
    const [ formSchema, setFormSchema ] = useState({});
    const [ formData, setFormData ] = useState({});
    const [ formDetails, setFormDetails ] = useState({});
    const [ otherDetails, setOtherDetails ] = useState({});
    const [ formInstance, setFormInstance ] = useState(null);
    const [ isFormValid, setIsFormValid ] = useState(false);
    const [ nosubmit, setNoSubmit ] = useState(true);
    const [ formIndex, setFormIndex ] = useState(1);
    const [ includedLanguages, setIncludedLanguages ] = useState('');
    const [ formsValidationStatus, setFormsValidationStatus ] = useState({});
    const [ checkValidationOnLoad, setCheckValidationOnLoad ] = useState(false);
    const [ stepsError, setStepsError ] = useState("");

    const { form_title, site_title, site_phone } = formDetails;

    let { tokenId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      window.goToStep = (stepNumber) => {
        setFormIndex(stepNumber);   // your React function
        setCheckValidationOnLoad(true);
      };
    }, []);

    useEffect(() => {
      fetchFormAPI();
    }, [ formIndex ]);

    useEffect(() => {
      window.Formio.createForm(formioRef.current, formSchema).then(function(form) {
        form.nosubmit = true;

        if(formData.hasOwnProperty('data')) {
          form.submission =  formData;
        }

        // Set FormIo
        setFormInstance(form);

        form.on("submit", async function(submission) {
          
        });

        form.on("change", async function(submission) {
          if(submission.hasOwnProperty('isValid')) {
            setIsFormValid(submission.isValid);
          }
        });

        // Check Validation On Page Load
        if (checkValidationOnLoad === true) {
          setTimeout(function() {
            form.checkValidity(form.submission, true);

            // SubmitButton Emit
            form.emit('submitButton');
          }, 500);
        }

        // Set on page load validation check to false.
        setCheckValidationOnLoad(false);
      });
    }, [ formSchema ]);

    async function fetchFormAPI() {

        // Set loader status
        setLoadingState(true);

        let authDataRes = await authCheck(tokenId);
        let { pid } = authDataRes;

        if(authDataRes.hasOwnProperty('error')) {
          onError(authDataRes);
        }

        if(pid && pid != "") {
          let formDataRes = await fetchPatientDocument(tokenId, formIndex);
          
          if(formDataRes.hasOwnProperty('error')) {
            onError(formDataRes);
          } else {
            setFormSchema(formDataRes['schema']);
            setFormData(formDataRes['data']);
            setFormDetails(formDataRes['form_details']);

            if(formDataRes.hasOwnProperty('other')) {
              setOtherDetails(formDataRes['other']);
            } else {
              setOtherDetails({});
            }

            if(formDataRes.hasOwnProperty('allowed_lang')) {
              setIncludedLanguages(formDataRes['allowed_lang']);
            } else {
              setIncludedLanguages('');
            }

            setAlertMsg("");
            errorRenderList(formIndex);
          }
        }

        // Set loader status
        setLoadingState(false);
    }

    const isFormValidIgnoreKey = (ignoreKey) => {
      return (
        Object.keys(formsValidationStatus).length === 0 ||
        Object.entries(formsValidationStatus)
          .filter(([key]) => key !== ignoreKey) // ignore this key
          .every(([_, arr]) => Array.isArray(arr) && arr.length === 0)
      );
    }

    const errorRenderList = (currentPage = 0) => {
      const stError = [];
      Object.keys(formsValidationStatus).forEach(key => {
          if (`_${currentPage}` != key && Array.isArray(formsValidationStatus[key]) && formsValidationStatus[key].length > 0) {
              const stepNumber = key.replace('_', '');

              const stError1 = [];
              if (Array.isArray(formsValidationStatus[key]) && formsValidationStatus[key].length > 0) {
                // If items can be arrays themselves, iterate nested arrays
                formsValidationStatus[key].forEach((item, index) => {
                  stError1.push(`<li><a href="#" class="text-danger step-link" onClick="goToStep(${stepNumber})">${item}</a></li>`);
                });
              }

              if (stError1.length > 0) {
                stError.push(`<li><a href="#" class="text-danger step-link" onClick="goToStep(${stepNumber})">Incomplete Form ${stepNumber}: please fill all required fields.</a><ul>${stError1.join("")}</ul></li>`);
              }
          }
      });

      if (stError.length > 0) {
        setStepsError(`<p>Please fix the following steps errors before submitting.</p><ul>${stError.join("")}</ul>`);
      } else {
        setStepsError("");
      }
    }

    const onBtnSave = async (action = 'save', el = null, callbackfun = null) => {
      
      const cElement = el != null ? el.currentTarget : null;

      let isFormValid = true;
      let currFormStatus = false;

      if (action == 'save') {
          // Check Form Validation
          isFormValid = true;
          currFormStatus = formInstance.checkValidity(formInstance.submission.data, true);

          if (currFormStatus === false) {
              // Check if the key exists and is an array, otherwise create an empty array
              formsValidationStatus[`_${formIndex}`] = [];

              formInstance.errors.forEach((err, index) => {
                  formsValidationStatus[`_${formIndex}`].push(err.message);
              });
          } else {
            // Check if the key exists and is an array, otherwise create an empty array
            formsValidationStatus[`_${formIndex}`] = [];
          }

          // 3. Clear the UI highlights only
          formInstance.checkValidity(formInstance.submission.data, false);
      } else {
          isFormValid = false;

          // Check Form Validation
          //formInstance.emit('submitButton');

          // Check validity
          currFormStatus = formInstance.checkValidity(formInstance.submission.data, true);

          // Current Form Status
          if (currFormStatus === false) {
              // Check if the key exists and is an array, otherwise create an empty array
              formsValidationStatus[`_${formIndex}`] = [];

              formInstance.errors.forEach((err, index) => {
                  formsValidationStatus[`_${formIndex}`].push(err.message);
              });
          } else {
            // Check if the key exists and is an array, otherwise create an empty array
            formsValidationStatus[`_${formIndex}`] = [];
          }

          isFormValid = 
              Object.keys(formsValidationStatus).length === 0 || 
              Object.values(formsValidationStatus).every(arr => Array.isArray(arr) && arr.length === 0);

          if (isFormValid === false) {
            // SubmitButton Emit
            formInstance.emit('submitButton');

            // Save data on submit
            action = 'save';
            isFormValid = true;
            // END
          }
      }

      if(formInstance && formInstance != null && isFormValid === true) {

        // Spinner
        if(cElement != null) cElement.querySelector('.spinner-border').classList.remove('d-none');

        setNoSubmit(false);

        const saveRes = await savePatientDocument(tokenId, formInstance.submission, action, formIndex);

        if(saveRes.length > 0 && saveRes[0].hasOwnProperty('status') && saveRes[0]["status"] === "submited") {
          navigate('/success');
          return;
        }

        if(saveRes.hasOwnProperty('error')) {
          if(saveRes['error'] === true) {
            onError(saveRes);
          } else if(saveRes['error'] === false) {
            onValidationError(saveRes);
          }
        } else {

          if(callbackfun != null && typeof callbackfun === 'function') {
            callbackfun();
            return true;
          }

          // Refetch patient document
          let formDataRes = await fetchPatientDocument(tokenId);

          if(formDataRes.hasOwnProperty('error')) {
            onError(formDataRes);
          } else {
            setFormData(formDataRes['data']);
            errorRenderList(formIndex);
          }
        }

        // Spinner
        if(cElement != null) cElement.querySelector('.spinner-border').classList.add('d-none');

        setNoSubmit(true);
      }
    }

    const onError = (error) => {
      navigate('/error');
    }

    const onValidationError = (error) => {
      setAlertMsg(error.message)
    }

    const setAlertMsg = (error) => {
      if(formInstance && formInstance != null) {
        let errorStr = error;

        if(Array.isArray(error)) {
          errorStr = '<ul><li>';
          errorStr += error.join("</li><li>");
          errorStr += '</li></ul>';
        }
 
        formInstance.root.setAlert('danger', errorStr);
      }
    }

    const handlePagination = async (action, fIndex, e = null) => {
      if(action == "next") {
        await onBtnSave("save", e, () => {
          setFormIndex(fIndex);
        });

      } else if(action == "prev") {
        setFormIndex(fIndex);
        setCheckValidationOnLoad(true);
      }
    }

    const actionBtn = () => {
      let formCountLabel = "";

      if(otherDetails.hasOwnProperty('current') && otherDetails.hasOwnProperty('total') && otherDetails['current'] > 0 && otherDetails['total'] > 0 ) {
        formCountLabel = `${otherDetails['current']}/${otherDetails['total']} `;
      }

      if(otherDetails.hasOwnProperty('prev') && otherDetails.hasOwnProperty('next')) {
        return (
          <div className="footer-block-container">
            <div className="m-0 footer-left-section">
              { otherDetails['prev'] > 0 &&
                  <button type="button" className="btn btn-outline-secondary border py-2 px-6 border w-100" onClick={(e) => handlePagination('prev', otherDetails['prev'], e) } >
                    <i class="bi bi-arrow-left"></i> <span className="btnText1">Previous</span>
                  </button>
              }
            </div>
            <div className="footer-middle-section"></div>
            <div className="footer-last-section">
              <button type="button" className="btn-save btn btn-outline-secondary border py-2 px-6" onClick={(e) => onBtnSave('save', e)} >
                <span className="btnText">Save</span> <i class="bi bi-save"></i>
                <div className="spinner-border spinner-border-sm mlc-2 d-none">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </button>
              { }
              { otherDetails['next'] > 0 &&
                  <button type="button" className="btn btn-primary py-2 px-6 border" onClick={(e) => handlePagination('next', otherDetails['next'], e) } >
                    <span className="btnText">{formCountLabel}Next</span> <i class="bi bi-arrow-right"></i>
                    <div className="spinner-border spinner-border-sm mlc-2 d-none">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </button>
              }
              { otherDetails['next'] == 0 &&
                  <button type="button" className="btn btn-primary py-2 px-6 border" onClick={(e) => onBtnSave('submit_all', e)} disabled={!isFormValidIgnoreKey(`_${formIndex}`)} >
                    <span className="btnText">Submit</span> <i class="bi bi-check-circle"></i>
                    <div className="spinner-border spinner-border-sm mlc-2 d-none">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </button>
              }
            </div>
          </div>
        );
      }

      return (
        <div className="footer-block-container">
          <div className="m-0 footer-left-section"></div>
          <div className="footer-middle-section"></div>
          <div className="footer-last-section">
            <button type="button" className="btn-save btn btn-outline-secondary border py-2 px-6" onClick={(e) => onBtnSave('save', e)} >
              <span className="btnText">Save</span> <i class="bi bi-save"></i>
              <div className="spinner-border spinner-border-sm mlc-2 d-none">
                <span className="visually-hidden">Loading...</span>
              </div>
            </button>
            { }
            <button type="button" className="btn btn-primary py-2 px-6 border" onClick={(e) => onBtnSave('submit', e)} >
              <span className="btnText">Submit</span> <i class="bi bi-check-circle"></i>
              <div className="spinner-border spinner-border-sm mlc-2 d-none">
                <span className="visually-hidden">Loading...</span>
              </div>
            </button>
          </div>
        </div>
      );
    }

    const formatPhoneNumber = (str) => {
      //Filter only numbers from the input
      let cleaned = ('' + str).replace(/\D/g, '');
      
      //Check if the input is of correct
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      
      if (match) {
        //Remove the matched extension code
        //Change this to format for any country code.
        let intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
      }
      
      return null;
    }

    if(loadingStatus === true || (Object.keys(formSchema).length === 0 && formSchema.constructor === Object) || formSchema == "") {
      return (
        <div className="form-page">
          <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="spinner-grow" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      );
    }

    let site_phone_str = site_phone != "" ? "tel:" + site_phone : "";

    return (
      <div className="form-page w-100 min-vh-100 d-flex flex-column">
        <div className="border-bottom">
          <div className="container max-w-screen-xl">
            <div className="py-3 px-0 d-flex justify-content-between align-items-center">
              <div>
              <h5 className="m-0 text-txt-emphasis text-lg font-semibold">{ site_title }</h5>
              <a href={site_phone_str} className="hover:no-underline"><p className="text-right text-sm m-0">{ formatPhoneNumber(site_phone) }</p></a>
              </div>
              <div className="ml-4 text-txt-emphasis">
                <img src="https://procareinjury.com/wp-content/uploads/2025/04/procare-logo.svg" alt="Logo" className="site-logo" />
              </div>
            </div>
          </div>
        </div>

        <div></div>

        <div className="flex-1">
          <div className="pb-2">
            <div className="container max-w-screen-xl">
              <div className="pt-2 px-0 d-flex justify-content-between align-items-center">
                <div></div>
                <div className="ml-4 text-txt-emphasis">
                  <Translate formIndex={formIndex} includedLanguages={includedLanguages} />
                </div>
              </div>
            </div>


            <div className="pt-8 container main-container max-w-screen-xl">
              <div className="px-6 mb-8 text-center">
                <h3 className="text-4xl text-body">{ form_title }</h3>
              </div>

              {stepsError && stepsError !== "" && (
                <div
                  className="alert alert-danger"
                  dangerouslySetInnerHTML={{ __html: stepsError }}
                />
              )}

              <div ref={ formioRef }></div>
            </div>
          </div>
        </div>

        <div className="safari-safe-area-bottom bg-white border-top shadow">
          <div className="py-3">
            <div className="container max-w-screen-xl">
              { actionBtn() }
            </div>
          </div>
        </div>

      </div>
    );
};

export default FormPage;